import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPlayCircle = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20.5 12a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M10.416 7.376A.75.75 0 0 0 9.25 8v8a.75.75 0 0 0 1.166.624l6-4a.75.75 0 0 0 0-1.248zm.334 7.223V9.4L14.648 12z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgPlayCircle;
